const CATALOG_FILTER_EXISTS = Symbol.for(
  // Random UUID to ensure no collisions
  "CATALOG_FILTER_EXISTS_0e15b590c0b343a2bae3e787e84c2111"
);

export { CATALOG_FILTER_EXISTS };
//# sourceMappingURL=api.esm.js.map
